import React, { Component } from 'react';
import { Plus, Search } from 'lucide-react';
import './PatientList.css';

// PatientCard'ı şimdilik burada tanımlıyoruz, daha sonra kendi dosyasına ayrılabilir.
const PatientCard = ({ patient, onPatientClick }) => (
    <div className="patient-card" onClick={() => onPatientClick(patient)}>
        <div className="patient-card-header">
            <div className="patient-avatar">
                {patient.firstName.charAt(0)}
                {patient.lastName.charAt(0)}
            </div>
            <div className="patient-card-info">
                <h3>{patient.firstName} {patient.lastName}</h3>
                <p className="patient-national-id">ID: {patient.nationalId}</p>
            </div>
        </div>
        <div className="patient-card-body">
            <div className="info-row"><strong>Phone:</strong> {patient.phone}</div>
            <div className="info-row"><strong>Last Exam:</strong> {patient.lastExamination}</div>
        </div>
        <div className="patient-card-footer">
            <span className={`status-badge ${patient.status.toLowerCase() === 'active' ? 'active' : 'follow-up'}`}>
                {patient.status}
            </span>
            <button className="view-btn">View Details</button>
        </div>
    </div>
);

class PatientList extends Component {
    render() {
        const {
            patients,
            onNewPatientClick,
            onPatientClick,
            searchText,
            onSearchChange,
            activeFilter,
            onFilterChange,
            hasPermission
        } = this.props;

        return (
            <div className="patient-list-container">
                <div className="list-header">
                    <h1>Patient List</h1>
                    <button 
                        className="add-button" 
                        onClick={onNewPatientClick} 
                        disabled={!hasPermission('addPatient')}
                    >
                        <Plus size={18} /> New Patient
                    </button>
                </div>
                <div className="search-filter-section">
                    <div className="search-box">
                        <Search size={20} color="#9ca3af" />
                        <input
                            type="text"
                            placeholder="Search by name, ID, or phone..."
                            value={searchText}
                            onChange={onSearchChange}
                        />
                    </div>
                    <div className="filter-buttons">
                        <button onClick={() => onFilterChange('All')} className={activeFilter === 'All' ? 'active' : ''}>All</button>
                        <button onClick={() => onFilterChange('Active')} className={activeFilter === 'Active' ? 'active' : ''}>Active</button>
                        <button onClick={() => onFilterChange('Follow-up')} className={activeFilter === 'Follow-up' ? 'active' : ''}>Follow-up</button>
                    </div>
                </div>
                <div className="patient-grid">
                    {patients.map(patient => (
                        <PatientCard
                            key={patient.id}
                            patient={patient}
                            onPatientClick={onPatientClick}
                        />
                    ))}
                </div>
                {patients.length === 0 && (
                    <div className="empty-state">
                        <h3>No Patients Found</h3>
                        <p>No patients match your search criteria.</p>
                    </div>
                )}
            </div>
        );
    }
}

export default PatientList;
